import type {TopSellingVehicleResponseBody} from '@dms/api/core';

import {DEFAULT_FALLBACK_MAKES, MARKET_FALLBACK_MAKES} from '../constants/marketFallbackMakes';

const TOP_MAKES_LIMIT = 12;

interface TopMakesInput {
  availableMakes: readonly string[];
  preferredMakes: readonly string[];
  topSelling: readonly TopSellingVehicleResponseBody[];
  market: string;
}

/** Preferences, observed sales in the model top list, market defaults, then remaining catalogue. */
export function getDisplayedTopMakes(input: TopMakesInput): string[] {
  const available = new Set(input.availableMakes);
  const counts = new Map<string, number>();
  for (const row of input.topSelling) {
    const key = row.make?.key;
    if (
      typeof key === 'string' &&
      typeof row.count === 'number' &&
      Number.isFinite(row.count) &&
      row.count > 0 &&
      available.has(key)
    ) {
      counts.set(key, (counts.get(key) ?? 0) + row.count);
    }
  }

  // Stable ties keep the first appearance in the top-selling model list.
  const ranked = [...counts].sort((a, b) => b[1] - a[1]).map(([key]) => key);
  const marketDefaults = Object.prototype.hasOwnProperty.call(MARKET_FALLBACK_MAKES, input.market)
    ? (MARKET_FALLBACK_MAKES[input.market] ?? DEFAULT_FALLBACK_MAKES)
    : DEFAULT_FALLBACK_MAKES;
  const candidates = [
    ...input.preferredMakes,
    ...ranked,
    ...marketDefaults.map((key) => `MAKE_${key}`),
    ...DEFAULT_FALLBACK_MAKES.map((key) => `MAKE_${key}`),
    ...input.availableMakes,
  ];

  return [...new Set(candidates)].filter((key) => available.has(key)).slice(0, TOP_MAKES_LIMIT);
}
